<nav class="navbar navbar-expand-lg app-navbar">
  <div class="container nav-shell">
    <a class="navbar-brand brand-link" routerLink="/assesments">Konvac</a>

    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="toggler-icon"></span>
      <span class="toggler-icon"></span>
      <span class="toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav nav-links" *ngIf="isAdmin">
        <li class="nav-item"><a class="nav-link" routerLink="/create-question" routerLinkActive="active">Create Question</a></li>
        <li class="nav-item"><a class="nav-link" routerLink="/list-questions" routerLinkActive="active">All Questions</a></li>
        <li class="nav-item"><a class="nav-link" routerLink="/list-types" routerLinkActive="active">Type/SubType</a></li>
        <li class="nav-item"><a class="nav-link" routerLink="/assesments" routerLinkActive="active">Assessments</a></li>
        <li class="nav-item"><a class="nav-link" routerLink="/recruitment" routerLinkActive="active">Recruitment</a></li>
      </ul>

      <ul class="navbar-nav nav-links" *ngIf="isMember">
        <li class="nav-item"><a class="nav-link" routerLink="/assesments" routerLinkActive="active">My Assessments</a></li>
        <li class="nav-item"><a class="nav-link" routerLink="/profile" routerLinkActive="active">Profile</a></li>
      </ul>

      <ul class="navbar-nav nav-links" *ngIf="isRecruiter">
        <li class="nav-item"><a class="nav-link" routerLink="/recruitment" routerLinkActive="active">Recruitment Dashboard</a></li>
      </ul>

      <div class="nav-actions" *ngIf="currentUser">
        <button type="button" class="signout-btn" (click)="signOut()">Sign Out</button>
      </div>
    </div>
  </div>
</nav>

<nav class="subnav" *ngIf="isAdmin" [@slideDown]>
  <div class="container">
    <ul class="subnav-list">
      <li class="subnav-item"><a class="subnav-link" routerLink="/admin-dashboard" routerLinkActive="active">Admin Dashboard</a></li>
      <li class="subnav-item"><a class="subnav-link" routerLink="/user-dashboard" routerLinkActive="active">User Dashboard</a></li>
      <li class="subnav-item"><a class="subnav-link" routerLink="/manage-scores" routerLinkActive="active">Industry/Role Fit Scoring</a></li>
      <li class="subnav-item"><a class="subnav-link" routerLink="/manage-behavior-categories" routerLinkActive="active">Behavior Categories Manager</a></li>
    </ul>
  </div>
</nav>
